// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"674":"e1c00fe4","941":"aea36148"}[chunkId] + ".chunk.js";
};